import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../../../app/common/constants/global.constant';
import { CommonService } from '../../../../common/services/common.service';
import { LivePartnerContentPage } from './../../../interfaces/partner-content-live.i';

@Component({
  selector: 'iposcen-partner-content-live-preview',
  templateUrl: './partner-content-live-preview.component.html',
  styleUrls: ['./partner-content-live-preview.component.scss']
})
export class PartnerContentLivePreviewComponent implements OnInit, OnDestroy {
  previewData: LivePartnerContentPage;
  isListPreview: boolean;
  headingLabel: string;
  bodyLabel: string;
  getStoredData = new Map();
  showDefaultImage = false;
  bodyLabelA: string;
  bodyLabelB: string;
  imageUrl: string;
  FILE_TYPE_IMAGE: string = GlobalConstants.FILE_TYPE_IMAGE;
  FILE_TYPE_VIDEO: string = GlobalConstants.FILE_TYPE_VIDEO;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private cmnSer: CommonService) { }
  @Input() pageData;
  ngOnInit(): void {
    this.headingLabel = GlobalConstants.PAGES_VIEW_HEADING_CAPS;
    this.bodyLabel = GlobalConstants.PAGES_VIEW_BODY;
    this.bodyLabelB = GlobalConstants.PAGES_VIEW_BODY_B;
    this.bodyLabelA = GlobalConstants.PAGES_VIEW_BODY_A;
    this.isListPreview = false;
    this.cmnSer.pageObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.previewData = data;
        if(this.previewData.singleImageContent) {
          this.imageUrl = this.previewData.singleImageContent.imageUrl;
        }
        this.getStoredData = this.previewData.storedImageData;
      });
    
    // passing default values
    this.previewData = {
      bgcolor: '#0068B5',
      hcolor: '#ffffff',
      layout: 4,
      logoMedia: {
        name: '',
        url: '',
        format: ''
      },
      layoutContent: [
        { imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', bodyA: '', bodyASize: GlobalConstants.MEDIUM, position: 'leftTop' },
        { imageBName: '', imageBFileType: '', imageBUrl: '', heading: '', bodyB: '', bodyBSize: GlobalConstants.MEDIUM, position: 'leftBottom' },
        { heroImageName: '', heroImageFileType: '', heroImageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'right' },
        { imageName: '', imageFileType: '', imageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'i-center' },
        { videoName: '', videoFileType: '', videoUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'v-center' }],
        imageAContent: {},
        imageBContent: {},
        heroImageContent: {},
        singleImageContent: {},
        videoContent: {},
        storedImageData: new Map(),
        hotSpotCurrentTab:0,
        hotspots : 
        {
          hotspot1: {assetID : "", assetName : "", assetType : "", assetUrl : "", body : "", bodyColor : "", bodyFontSize : "14px", heading : "", headingColor : ""},
          hotspot2: {assetID : "", assetName : "", assetType : "", assetUrl : "", body : "", bodyColor : "", bodyFontSize : "14px", heading : "", headingColor : ""},
          hotspot3: {assetID : "", assetName : "", assetType : "", assetUrl : "", body : "", bodyColor : "", bodyFontSize : "14px", heading : "", headingColor : ""},
          hotspot4: {assetID : "", assetName : "", assetType : "", assetUrl : "", body : "", bodyColor : "", bodyFontSize : "14px", heading : "", headingColor : ""}
        },  
    };
    if (this.pageData) {
      this.isListPreview = true;
      this.pageData.heading = this.pageData.heading || ' ';
      this.pageData.body = this.pageData.body || ' ';
      this.previewData = JSON.parse(JSON.stringify(this.pageData));
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  fontSize(size) {
    if (size === GlobalConstants.SMALL) {
      return GlobalConstants.FONTSIZE_12PX;
    }
    if (size === GlobalConstants.MEDIUM) {
      return GlobalConstants.FONTSIZE_14PX;
    }
    if (size === GlobalConstants.LARGE) {
      return GlobalConstants.FONTSIZE_16PX;
    }
  }

}
